// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"9f439a95","513":"8d2682ec","703":"cd7468e5","787":"70b6c3ef"}[chunkId] + ".chunk.js";
};